import React from "react"
// import { css } from "@emotion/core"
import { graphql } from "gatsby"
// import { rhythm } from "../../utils/typography"
import Layout from "./layout"


import Collapse from '@material-ui/core/Collapse'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'

import Img1 from "./_images/git.png"


const IndexPage = ({ data }) => {

  const [p1, showProject1] = React.useState(true)
  const [p2, showProject2] = React.useState(true)
  const [p3, showProject3] = React.useState(true)
  const [p4, showProject4] = React.useState(true)

  const [e1, showExercise1] = React.useState(true)
  const [e2, showExercise2] = React.useState(true)
  const [e3, showExercise3] = React.useState(true)
  const [e4, showExercise4] = React.useState(true)
  const [e5, showExercise5] = React.useState(true)
  const [e6, showExercise6] = React.useState(true)
  const [e7, showExercise7] = React.useState(true)
  const [e8, showExercise8] = React.useState(true)
  const [e9, showExercise9] = React.useState(true)
  const [e10, showExercise10] = React.useState(true)






  function handleClick1(id) {
    switch (id) {
      case "p1":
        showProject1(!p1)
        break;
    }
  }
  function handleClick2(id) {
    switch (id) {
      case "e1":
        showExercise1(!e1)
        break;
    }
  }
  function handleClick3(id) {
    switch (id) {
      case "e2":
        showExercise2(!e2)
        break;
    }
  }
  function handleClick4(id) {
    switch (id) {
      case "e3":
        showExercise3(!e3)
        break;
    }
  }
  function handleClick5(id) {
    switch (id) {
      case "e4":
        showExercise4(!e4)
        break;
    }
  }

  function handleClick6(id) {
    switch (id) {
      case "e5":
        showExercise5(!e5)
        break;
    }
  }

  function handleClick7(id) {
    switch (id) {
      case "p2":
        showProject2(!p2)
        break;
    }
  }

  function handleClick8(id) {
    switch (id) {
      case "e6":
        showExercise6(!e6)
        break;
    }
  }

  function handleClick9(id) {
    switch (id) {
      case "p3":
        showProject3(!p3)
        break;
    }
  }

  function handleClick10(id) {
    switch (id) {
      case "e7":
        showExercise7(!e7)
        break;
    }
  }

  function handleClick11(id) {
    switch (id) {
      case "p4":
        showProject4(!p4)
        break;
    }
  }
  function handleClick12(id) {
    switch (id) {
      case "e8":
        showExercise8(!e8)
        break;
    }
  }
  function handleClick13(id) {
    switch (id) {
      case "e9":
        showExercise9(!e9)
        break;
    }
  }
  function handleClick14(id) {
    switch (id) {
      case "e10":
        showExercise10(!e10)
        break;
    }
  }

  return (

    <Layout>
      <h1><p>Projects</p></h1>
      <div className="accordion-list">
       <ListItem id='p1' className="accordion" button onClick={() => handleClick1("p1")}>
          <ListItemText primary='Project 1' className="accordion-heading  maxw-20" /> Hyperlinked Set
        </ListItem>
        <Collapse in={!p1} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <img style={{ marginBottom: `.5rem` }} src={'https://d2w9rnfcy7mm78.cloudfront.net/662383/original_5ab90192d02c4430a9980f6a9bdf3bd7.gif?1469307808'}></img>
              <h6 style={{ marginTop: `0rem`, marginBottom: `3rem` }}>Ted Nelson, <i>hypertext links in ELF (Evolutionary List File)</i>, 1998</h6>
              <h5>Overview</h5>
              Hyperlinks are the essence of web. For a user experience, designers need to create a hyperlink structure that allows various kinds of browsing content. Based on how the contents are parsed and connected to each other via hyperlinks, a designer can create a new reading of the content. In this project, we will explore how we can use hyperlinks to catalogue items in a creative way.
              <h5>Assignment</h5>
              <p>Curate a set of content. For the content, you will select items such as books, objects, images, drawings, texts, quotes, sounds, videos, anything that interests you (minimum 3 items). You must be able to explain how these items are connected. </p>
              <p>Design and develop a hyperlink structure that serves as a catalogue of the items. You will build a website that explains the connection between the items through hyperlinks. The outcome must include a landing page, links to all items you selected, and a description about the set. The structure and organization of the content is up to you but users should be able to understand the connection of the items within the set along why they are chosen, an overview of all materials in the set, and individual destinations with details about each item in the set.</p>
              <h5>Things to consider</h5>
              <ul>
                <li>What aspect of the set do you want to present?</li>
                <li>How the catalogue of items should be broken down into units?</li>
                <li>How individual units of the set should be connected? Do you present each unit sequentially, or all instantaneously? Are you allowing the user choices?</li>
                <li>How could links be indicated? Do you have different types of links?</li>
                <li>Should the hyperlink structure be placed in a single webpage or multiple webpages?</li>
              </ul>
              <h5>Schedule</h5>
              <h6>10/08/24: Planning - Research and Sketch</h6>
              <ul>
                <li>Collect a list of items you want to catalogue and articulate your curatorial perspective and goals of the catalogue.</li>
                <li>Find 1–2 other websites that handle similar information in interesting ways and analyze why they work well.</li>
                <li>Make 2 different link structure ideas for your catalogue, each addressing how all items will link to each other. The sketch could be a form of sitemap, diagram, or wireframe. Include a 1–2 sentence description for each sketch.</li>
                <li>Aggregate all of this information into a proposal document. In the class, you will give a 5 minute presentation based on your proposal.</li>
              </ul>
              <h6>10/15/24: Design and Prototype </h6>
              <ul>
                <li>Based on your sketch, you will design a series of screen sequences showcasing the main flow of your hyperlink structure by using a prototype software (Figma, Adobe XD, etc).</li>
               
              </ul>
              <h6>10/29/24: Development</h6>
              <ul>
                <li>Start to develop your website using HTML/CSS/JS. Remember correct file organization and semantic markup. Carefully prioritize tasks and finish them in order: what are the most important elements/functionalities in your project?
                  In this stage, the basic link flow of your site should be basically functioning as intended. 
                </li>
              </ul>
              <h6>10/29/24: Testing, Review, and Launch</h6>
              <ul>
                <li>Refine your design and web prototype. Upload your final project to your GitHub repository, and add links to the project on your Github homepage. Post the links in Slack with the channel <span class="code">#(yourname)</span>.</li>
              </ul>
              <h5>References</h5>
              <h6>Sequential</h6>
              <ul>
                <li><a href="http://www.teleportacia.org/war/">Olia Lialina, My Boyfriend Came Back from the War </a></li>
                <li><a href="https://hitosteyerl.vanabbe.nl/">Studio Moniker, a digital campaign for Hito Steyerl's exhibition at Van Abbemuseum</a></li>
              </ul>
              <h6>Map</h6>
              <ul>
                <li><a href="https://animalsasobjects.org/">Trust, Son La Pham and Claire Tolan, Animals as Objects</a></li>
                <li><a href="http://torquetorque.net/">Jake Dow-Smith Studio, Torque Editions </a></li>
                <li><a href="http://predominant.ly/">Open Work, Predominant.ly</a></li>
              </ul>
              <h6>Category or tag based</h6>
              <ul>
                <li><a href="https://www.catalogtree.net/">Catalogtree, Catalogtree 5.0</a></li>
                <li><a href="https://anishkapoor.com/">Anish Kapoor website</a></li>
                <li><a href="http://exhibitions.guggenheim.org/storylines/">Guggenheim, Storylines </a></li>
              </ul>
              <h6>Presentation strategies</h6>
              <ul>
                <li><a href="https://www.are.na/daniel-lefcourt/compositional-strategies">(Are.na) Compositional Strategies</a></li>
                <li><a href="https://www.are.na/minkyoung-kim/presenting-multiple">(Are.na) Presenting Multiple</a></li>
                <li><a href="https://www.amazon.com/Infinity-Lists-Illustrated-Essay/dp/0847832961">Umberto Eco, The Infinity of Lists </a></li>
              </ul>
            </div>
          </List>
        </Collapse>
        <ListItem id='p2' className="accordion" button onClick={() => handleClick11("p4")}>
          <ListItemText primary='Project 2' className="accordion-heading  maxw-20" /> Change Over Time
        </ListItem>
        <Collapse in={!p4} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <img style={{ marginBottom: `.5rem`, maxWidth: `200px` }} src={Img1}></img>
              <h6 style={{ marginTop: `0rem`, marginBottom: `3rem` }}>
                Diagram for GIT, from <i><a href="https://www.dropbox.com/scl/fi/wx7c9odlxgeopttk666zj/david_reinfurt_infinite_versioning.pdf?rlkey=eb18wp6paadcxknoy125qkji5&dl=0" target="_blank">Infinite Versioning</a></i>, David Reinfurt, 2014
              </h6>
              <p style={{ lineHeight: '1', paddingLeft: '2.7rem' }}>
                <span class="small">
                  Many of our sites are designed to change. They don’t change on their own; rather, they are dependent on limitless streams of dynamic external input, and their design is built around ideas about the nature of those streams.
                  — Dan Michaelson (Linked by Air), <i><a href="https://www.dropbox.com/s/vrbohg2yuvc8ex0/Linked%20by%20Air-%20Change.pdf?dl=0" target="_blank" rel="noopener noreferrer">Change Over Time</a></i>
                </span>
              </p>
              <p style={{ lineHeight: '1', paddingLeft: '2.7rem' }}>
                <span class="small">
                  We’re working on our new website. Instead of promising a grand relaunch, we decided to keep the work in plain view. During the next few months, you’ll be able to see the changes taking place here: different themes, typographic styles and image treatments will be tried occasionally. It may happen very quickly. It may take a long time, and we might end up with something almost unchanged after all. In any case, you will see when it’s done that it’s done
                  — Sulki & Min, 2013 </span>
              </p>



              <h5>Overview</h5>


              A website is a medium that is intended to present changing content and form. Web technology allows users to easily switch the content and provides interactions that create visual changes over time. Considering a life of a website after it is launched, designers need to consider this technological condition for their design. In this assignment, we will be taking this challenge as a creative context and explore how to embrace and expand changes as a part of your design.
              <h5>Assignment</h5>
              Choose an event. The event could be already existing or fictional, but has to be a time-based happening(s): an exhibition, a music festival, etc. Create a single-page website that informs the viewer about the event reflecting its progress. Think about what events’ changing points are over time, and how the website could have visual connections with these changes. The website must present <i>at least two different states</i> following the event’s timeline. The series of these changes should be applied through the entire website as a cohesive visual direction, more than a few elements on the website. The outcome must include the basic information about the event (the title, the time, a description).
              <h5>Things to consider</h5>
              <ul>
                <li>What is the purpose for the website in relation to the actual event: advertisement, archive, or an event itself (a live performative space), etc.</li>
                <li>Triggers to initiate the change: time, location, weather, user interactions, etc.</li>
                <li>Variables between the changes: how the website could be understood as a consistent / comprehensive visual container of the event but also create enough differences along the context of its change</li>
                <li>Possible timeframes of change: 1 second, 1 minute, 1 hour, 1 day, 1 month, or some other schedule</li>
              </ul>
              <h5>Schedule</h5>
              <ul>
                <h6>11/05/24: Planning and Design Sketch</h6>
                <li>
                  Develop a storyboard of at least two screens that illustrate key changing points of your event over time.
                  Based on your storyboard, create an initial visual design with at least one screen that includes visual layout and major content elements.
                  Make sure to use design software like Figma or Adobe XD for both the storyboard and visual design to ensure proper scaling and spacing (No hand-drawings!)
                </li>
                <h6>11/12/24: Design and Prototype Research</h6>
                <li>Develop and refine your screen designs further. Start to research relevant web programming languages and test them out in browser. </li>
                <h6>11/19/24: Prototype</h6>
                <li>Prototype your design in browser. In this stage, each stage of 'change' on your prototype should be presented as intended. Carefully prioritize programing tasks and finish them in order. </li>
                <h6>11/26/24: Test and launch</h6>
                <li>Test your prototype to identify and address any issues or bugs. Refine the design or functionality as needed. Once the site is ready, upload your final project to your Github repository, and add links to the project on your Github homepage. Post the links in Slack with the channel <span class="code">#(yourname)</span>. </li>
              </ul>

              <h5>References</h5>

              <ul>
                <li><a href="https://drive.google.com/file/d/1iYloXf-fpC-kVRcjt4ZtpmI927ZtoAiX/view?usp=sharing" target="_blank">Slides</a>
                </li>
              </ul>
              <h6>Clock</h6>
              <ul>
                <li><a href="http://hummingbirdclock.info/" target="_blank" rel="noopener noreferrer">The Hummingbird Clock</a></li>
                <li><a href="http://work.damonzucconi.com/floating-point-year/" target="_blank" rel="noopener noreferrer">Floating Point Year</a></li>
                <li><a href="http://o-r-g.com/apps/wyoscan" target="_blank" rel="noopener noreferrer">Wyoscan</a></li>
              </ul>
              <h6>Tracing changes</h6>
              <ul>
                <li><a href="https://www.hoverstat.es/features/second-thoughts" target="_blank" rel="noopener noreferrer">Second Thoughts</a></li>
                <li><a href="https://averyreview.com/issues/1/partial-recall" target="_blank" rel="noopener noreferrer">Hottest To Coldest</a></li>
              </ul>
              <h6>Open/close</h6>
              <ul>
                <li><a href="https://radioamnion.net/" target="_blank" rel="noopener noreferrer">Radio Amnion</a></li>
              </ul>
              <h6>Streaming</h6>
              <ul>
                <li><a href="https://www.youtube.com/watch?v=qTg6Gl3gD8M&ab_channel=sagmeisterinc" target="_blank">Stefan Sagmeister's old website</a></li>
                <li><a href="http://allatonce.space/" target="_blank" rel="noopener noreferrer">All at Once</a></li>
              </ul>
            </div>
          </List>
        </Collapse> 
        {/* <ListItem id='p3' className="accordion" button onClick={() => handleClick9("p3")}>
          <ListItemText primary='Project 3' className="accordion-heading  maxw-20" /> Input / Output
        </ListItem>
        <Collapse in={!p3} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <img style={{ marginBottom: `.5rem` }} src={'https://upload.wikimedia.org/wikipedia/commons/2/21/Textbox2.gif'}></img>
              <h6 style={{ marginTop: `0rem`, marginBottom: `3rem` }}><i>Text entry box from <a href="https://en.wikipedia.org/wiki/Text_box" target="_blank" rel="noopener noreferrer">Wikipedia</a></i></h6>
              <h5>Overview</h5>
              The notions of input and output are the most basic concepts of computation. With a lens of computation, web content and its visual presentation highly relies on the process of presenting the desired output based on a given input(s). To design a user-driven website, designers are mostly in a situation to design a container for future inputs, which requires a systems-driven approach that might best be described as architecture, rather than designing a layout that marries a specific form to content. In this context, how can the container be flexible enough to represent these types of dynamic contents? In this project, we will explore web as a platform for dynamic contents, focusing on how designing the container could influence the future contents.
              <h5>Assignment</h5>
              Create a single webpage that instructs a user to input information using input forms such as text fields, radio buttons, toggle switch, etc. Carefully design the instruction to set up the parameters of the future contents. Once users submit their input, your website must display the result in a visual form. Consider order, sequence, or any interactive elements to display the results.
              <h5>Things to consider</h5>
              <h6>Input</h6>
              <ul>
                <li>How to gather visitor input: Consider various approaches such as clear instructions, visual cues, etc., to collect visitor input effectively.
                </li>
                <li>Parameters of the instruction: word count, number of fields/commands, autocomplete</li>
              </ul>

              <h6>Output</h6>
              <ul>
                <li>Dynamic content subject to change: Identify elements such as text, forms, or visuals that are variable and can alter based on user interactions.</li>
                <li>Effective presentation of outputs: Explore methods to present outputs in a manner that adjusts according to visitors' responses or reactions</li>
              </ul>
              <h6>Static content</h6>
              <ul>
                <li>Invariable elements: setup elements such as static text, images, sound, etc., that remain consistent and unchanged regardless of interactions from visitors.



                </li>
              </ul>
              <h5>Schedule</h5>
              <h6>11/07/23: Planning/research/sketch</h6>
              Show designed screens with minimum 3 outcomes with different forms of output by using a design software such as Figma or Adobe XD (no hand-drawings!) Basic prototype should be planned out.
              <h6>11/14/23: Mock up</h6>
              Revise the design and begin development
              <h6>11/21/23: Testing</h6>
              Test and launch a semi-final version of your project on your Github repository before the class.
              <h6>11/28/23: Final </h6>
              Upload your final site your Github repository.
              <h6>!important: 12/05/23 — Class Documentation Due</h6>
              Collect and upload exercises and projects made by the class on your Github repository and Dropbox Folder. More detailed information will be provided before the last week.


              <h5>References</h5>
              <h5>Web projects</h5>
              <ul>
                <li>Participatory tools: <a href="https://vimeo.com/314292864" target="_blank" rel="noopener noreferrer">Deutsch-land</a>, <a href="https://dear-new-york.com/" target="_blank" rel="noopener noreferrer">Dear New York</a>, <a href="https://studiomoniker.com/projects/place-a-stone" target="_blank" rel="noopener noreferrer">Place a Stone</a></li>
                <li>Form experimentations: <a href="https://museumatlarge.com/" target="_blank">Museum at Large</a>, <a href="http://haha.services/" target="_blank" rel="noopener noreferrer">Haha Services</a></li>
                <li>Type presentation tools:  <a href="https://occupantfonts.com/" target="_blank" rel="noopener noreferrer">Occupant Fonts</a>, <a href="https://radimpesko.com/fonts/agipo" target="_blank" rel="noopener noreferrer">Radim Pesko</a>, <a href="https://www.eliashanzer.com/phase/" target="_blank">Phase</a>, <a href="https://www.recursive.design/" target="_blank" rel="noopener noreferrer">Recursive</a>,</li>
              </ul>
              <h5>Readings</h5>
              <ul>
                <li>Michael Rock, <a href="https://2x4.org/ideas/2014/wysiwyg/" target="_blank" rel="noopener noreferrer">WYSIWYG</a></li>
                <li>Allen Tan, <a href="http://contentsmagazine.com/articles/made-to-measure/" target="_blank" rel="noopener noreferrer">Made to Measure</a></li>
              </ul>
              <h5>Resources</h5>
              <ul>
                <li><a href="https://material.io/components/text-fields/#anatomy" target="_blank" rel="noopener noreferrer">Text field anatomy</a></li>
                <li><a href="https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input" target="_blank" rel="noopener noreferrer">The Input (Form Input) element</a></li>
                <li><a href="https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API" target="_blank" rel="noopener noreferrer">Web Storage API</a></li>
                <li><a href="https://www.json.org/json-en.html" target="_blank" rel="noopener noreferrer">Introducing JSON</a></li>
              </ul>
            </div>
          </List>
        </Collapse> */}
      </div>
      <h1 style={{ marginTop: `5rem` }}><p>Exercises</p></h1>
      <div className="accordion-list" style={{ marginTop: `0rem`, marginBottom: `5rem` }}>
        <ListItem id='e1' className="accordion" button onClick={() => handleClick2("e1")}>
          <ListItemText primary='Exercise 1' className="accordion-heading  maxw-20" /> Hello World
        </ListItem>
        <Collapse in={!e1} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <h6 style={{ marginTop: `0rem` }}>Due 09/17/24</h6>
              <ul>
                <li>Make a new html file named  <span class="code">index.html</span> in Sublime text.</li>
                <li>Copy a basic html structure from <a href="https://developer.mozilla.org/en-US/docs/Learn/Getting_started_with_the_web/HTML_basics#anatomy_of_an_html_document">here</a> and paste on your html.</li>
                <li>Modify the code with a copy 'Hello World' and save the file in your Github folder directory on your local computer.</li>
                <li>Commit the html file to Github. This html file will be the landing page on your Github site.</li>
                <li>Post the link to your new Github web address that you just created in Slack with the channel <span class="code">#(yourname)</span>.</li>
              </ul>
            </div>
          </List>
        </Collapse>
        <ListItem id='e2' className="accordion" button onClick={() => handleClick3("e2")}>
          <ListItemText primary='Exercise 2' className="accordion-heading  maxw-20" /> Handmade Web — HTML
        </ListItem>
        <Collapse in={!e2} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <h6 style={{ marginTop: `0rem` }}>Due 09/17/24</h6>

              <p>Semantically mark up an essay on J. R. Carpenter's <i>Handmade Web</i>. You will create a set of html pages (two or more) that are connected by hyperlinks. </p>
              <ul>
                <li>To begin, download text <a href="https://drive.google.com/file/d/1s2HmTbiFH5bhvYP9v3BMO0DTgWeeZZ1R/view?usp=sharing" target="_blank">here</a> and divide the text into multiple sections to create hyperlink sequences.</li>
                <li>Download HTML template <a href="https://drive.google.com/file/d/1FpWgegiLkPblTFwCR2E423cx_CeBfGBp/view?usp=sharing" target="_blank">here</a> and save at the appropriate location in your local computer. Duplicate them to match the number of your text sections.</li>
                <li>Open each HTML template file in your text editor and copy and paste the relevant sections from the essay into the template. </li>
                <li>Mark-up the document by keeping in mind which HTML tags are appropriate for which segments of content. 
                  During this step, carefully proofread for correct glyphs (such as quotation marks, dashes, and other Unicode characters) and ensure proper formatting. You may also consider reformatting these elements typographically to suit your design—for example, by indenting or italicizing a quote block instead of using quotation marks.</li>
                <li>Add a hyperlink on each page to connect one another.</li>
                <li>Test your results by opening the local HTML file in your chosen web browser.</li>
                <li>Upload your HTML file to your GitHub repository, and test your results again with the repository URL</li>
                <li>Post the link in Slack with the channel <span class="code">#(yourname)</span>.</li>
              </ul>
              <h5>References</h5>
              <h6>Multi-page Storytelling Examples</h6>
              <ul>
                <li>Olia Lialina, <a href="http://www.teleportacia.org/war/" target="_blank"> My Boyfriend Came Back from the War</a></li>
                <li>Closky, <a href="https://awp.diaart.org/closky/" target="_blank">Do You Want Love or Lust?</a></li>
                <li>Penelope Umbrico, <a href="https://www.ubu.com/contemp/umbrico/AllCatalogs/index.html" target="_blank">All Catalogues</a></li>
              </ul>
              <h6>Web Typography</h6>
              <ul>
                <li><a href="https://practicaltypography.com/" target="_blank">Butterick's Practical Typography</a></li>
                <li><a href="https://www.typewolf.com/cheatsheet" target="_blank">TypeWolf: Typography Cheatsheet</a></li>
                <li><a href="https://www.unicode.org/charts/nameslist/n_2000.html"  target="_blank">Unicode General Punctuation</a></li>
              </ul>
            </div>
          </List>
        </Collapse>
        <ListItem id='e3' className="accordion" button onClick={() => handleClick4("e3")}>
          <ListItemText primary='Exercise 3' className="accordion-heading  maxw-20" /> Handmade Web — CSS
        </ListItem>
        <Collapse in={!e3} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <h6 style={{ marginTop: `0rem` }}>Due 09/24/24</h6>
              <p>Using your new knowledge of some simple CSS styling properties, style the Handmade Web content that you already marked up in a previous exercise. <i>Create an external CSS file</i> to style your content, experimenting with color, scale, and positioning to further familiarize yourself with this new language.</p>
              <h6>Step 1</h6>
              <p>During the class, focus on the basic CSS setup and testing micro styles (fonts, color, inline typography styles, etc). Keep in mind webfont implementation and font properties.</p>
              <h6>Step 2</h6>
              <p>After the class, continue styling the document per the <a href="https://docs.google.com/presentation/d/1lK0gxY9rQ1YiWGYLFniFbaEfrVLSoMU3KdUKOLvpMQo/edit?usp=sharing" target="_blank" rel="noopener noreferrer">CSS Layout</a> checklist below:</p>
              <ul>
                <li>Review markup: Ensure proper use of inline and block-level elements in your HTML.</li>
                <li>Define position: Set positioning with  <span class="code">display</span>,  <span class="code">float</span>, and  <span class="code">position</span> properties. Setting borders and toggling the border style could be helpful.</li>
                <li>Adjust padding and margin: Customize spacing using padding and margin.</li>
                <li>Box properties: Modify box properties like  <span class="code">width</span>,  <span class="code">height</span>,  <span class="code">border</span>, etc.</li>
                <li>Alignment: Consider using  <span class="code">float</span> or CSS Grid for element alignment.</li>
              </ul>
              <p>Update your html file to your GitHub repository, and add a link to the page on the GitHub homepage. Post the link in Slack with the channel <span class="code">#(yourname)</span>.</p>
            </div>
          </List>
        </Collapse>
        {/* <ListItem id='e4' className="accordion" button onClick={() => handleClick5("e4")}>
                <ListItemText primary='Exercise 4' className="accordion-heading  maxw-20" /> Style an Interview
            </ListItem>
            <Collapse in={!e4} timeout="auto"  unmountOnExit>
              <List component="div" disablePadding>
              <div className="accordion-content">
                <h6 style={{ marginTop: `0rem`}}>Due 09/24/24</h6>
              <p>You will select a transcript from an interview from an online source. The interview can be between an artist, a politician, a news reporter, etc. The text should include no more than 3 people and only be a few pages in length (for your own sake). Using your selected text, republish the interview onto a single webpage such that it targets a different audience than the original interview. Establish distinct typographic styling for each alternating voice — consider font, size, color and scale. Integrate at least 4 images into the body of the interview that are relevant to the content discussed in the interview.</p>
              <p>Update your html file to your GitHub repository, and add a link to the page on the GitHub homepage. Post the link in Slack with the channel <span class="code">#(yourname)</span>.</p>
              </div>
              </List>
            </Collapse>  */}
        <ListItem id='e5' className="accordion" button onClick={() => handleClick6("e5")}>
          <ListItemText primary='Exercise 4' className="accordion-heading  maxw-20" /> CSS letterforms (1)
        </ListItem>
        <Collapse in={!e5} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <h6 style={{ marginTop: `0rem` }}>Due 10/01/24</h6>
              <p>Choose a letter from the alphabet (excluding I, L, and T), and design more than 5 distinct variations of that letter using only HTML and CSS. </p>
              <ul>
                <li>Based on CSS properties covered in the previous lectures, think about how to use CSS to create complex shapes. Focus on carefully constructing HTML elements, as the nesting structure can help group each stroke and shape the letterform.</li>
                <li>Consider how geometric forms and their variations can be applied to the letter. Explore the use of color, shadows, and transparency to highlight both the positive and negative spaces within your designs.</li>
                <li>Upload your html files to your GitHub repository, and add links to the pages on the GitHub homepage. Post the links in Slack with the channel <span class="code">#(yourname)</span>.</li>
              </ul>
            </div>
          </List>
        </Collapse>
         <ListItem id='e6' className="accordion" button onClick={() => handleClick8("e6")}>
          <ListItemText primary='Exercise 5' className="accordion-heading  maxw-20" /> CSS letterforms (2)
        </ListItem>
        <Collapse in={!e6} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <h6 style={{ marginTop: `0rem` }}>Due 10/10/24</h6>
              <p>
                Choose one of your letterforms from the previous exercise and create a new HTML page with the chosen letterform. You will apply your new knowledge of CSS motion properties to enhance and enliven the composition.
                Use at least 1 CSS transition or 1 CSS animation when the user hovers over some component of the letterforms.</p>
              <p>
                Think about interactivity—given the content and structure of the letterforms, what can happen on hover?
                You may want to reconsider alignment of each strokes, or other graphic elements such as letter space and background color, that can be incorporated to illustrate motion.
              </p>
              <p>
                Upload your html files to your GitHub repository, and add links to the pages on the GitHub homepage. Post the links in Slack with the channel <span class="code">#(yourname)</span>.
              </p>
              <h6>Past Examples</h6>
              <ul>
                <li><a href="http://b.parsons.edu/~sabbm950/ex8letter.html" target="_blank">P by Marine Sabbagh</a></li>
                <li><a href="https://dinginginging.github.io/ding/ex4/type.html" target="_blank">Q by Steven Ding</a></li>
                <li><a href="https://femathjr.github.io/Exercise_5-6_CSS_Letterforms/4_letter_styles/4letterVersionsV2.html" target="_blank">F by Fred E. Mathelier Jr.</a></li>
              </ul>
              <h6>Demos</h6>
              <ul>
                <li><a href="https://codepen.io/mkimkimkimk/pen/oNwOeMN" target="_blank">Style child element when hover on parent</a></li>
                <li><a href="https://codepen.io/mkimkimkimk/pen/rNvdZEp" target="_blank">Style an element when hover on a sibling element</a> by using <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/Adjacent_sibling_combinator" target="_blank">CSS adjacent sibling combinator</a></li>
                <li><a href="https://codepen.io/mkimkimkimk/pen/xxjWyZy" target="_blank">Or when there are other items in between</a> by using <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/General_sibling_combinator" target="_blank">CSS general sibling combinator</a></li>
              </ul>
            </div>
          </List>
        </Collapse> 
        
        <ListItem id='e10' className="accordion" button onClick={() => handleClick14("e10")}>
          <ListItemText primary='Exercise 6' className="accordion-heading  maxw-20" /> Dark Mode
        </ListItem>
        <Collapse in={!e10} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <h6 style={{ marginTop: `0rem` }}>Due 10/15/24</h6>
              <p>Based on the toggle demo from the recording, we will create another view mode in your GitHub repository index page by using JavaScript toggle. You can find more demos here: <a href="https://github.com/RISD-Code-Lab/spring2021" target="_blank">CodeLab: Session 1 — JavaScript toggle</a>.
              </p>
              <ul>
                <li>Create and style a button that will serve as a toggle button in your GitHub index page.</li>
                <li>Add jQuery CDN on the <span class="code">head</span> of your html to load jQuery in your project.</li>
                <li>Create a new .js file and add a link to it under your jQuery script tag. </li>
                <li>Choose existing html elements or add new HTML elements you want to toggle its style when clicking on the button. Carefully point out the element by using CSS property, adjust the html structure to make it efficient if you need.</li>
              </ul>
              <h5>References</h5>
              <ul>
                <li>Dark Mode (<a href="https://developer.apple.com/design/human-interface-guidelines/ios/visual-design/dark-mode" target="_blank">iOS</a>, <a href="https://support.apple.com/guide/mac-help/use-a-light-or-dark-appearance-mchl52e1c2d2/mac" target="_blank">Mac</a>, <a href="https://developer.android.com/guide/topics/ui/look-and-feel/darktheme" target="_blank">Android</a>)</li>
                <li>Tiger Dingsun, <a href="https://tdingsun.github.io/tiger/" target="_blank">Ballast</a></li>
              </ul>
              <h5>Resources</h5>
              <ul>
                <li><a href="https://github.com/RISD-Code-Lab/spring2021" target="_blank">CodeLab: Session 1 — JavaScript toggle</a></li>
                <li><a href="https://api.jquery.com/toggleclass/" target="_blank">JQuery Toggle</a></li>
                <li><a href="https://css-tricks.com/a-complete-guide-to-dark-mode-on-the-web/" target="_blank">A Complete Guide to Dark Mode on the Web</a></li>

              </ul>
              <h4>Based on an assignment in CCA Interactive I by Chris Hamamoto and Marie Otuska</h4>
            </div>
          </List>
        </Collapse>
       <ListItem id='e7' className="accordion" button onClick={() => handleClick10("e7")}>
          <ListItemText primary='Exercise 7' className="accordion-heading  maxw-20" /> Media Query Relay
        </ListItem>
        <Collapse in={!e7} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <img style={{ marginBottom: `.5rem` }} src={'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/14390049254313.58af348ed662e.gif'}></img>
              <h6 style={{ marginTop: `0rem`, marginBottom: `3rem` }}><i> <a href="https://essenmitsosse.de/pixel/?showcase=true&slide=2" target="_blank" rel="noopener noreferrer">Marcus Blättermann, »Responsive Pixel Art«, 2016</a></i></h6>
              <h6 style={{ marginTop: `0rem` }}>Due to 11/21/24</h6>
              <p>In this exercise, we will use our individual responses to media queries as a way to reveal our class dynamics. In the beginnings of the Surrealist movement, leading artists would play a game called <a href="https://en.wikipedia.org/wiki/Exquisite_corpse" target="_blank" rel="noopener noreferrer">Exquisite Corpse</a> because they believed that individual poetic fragments reflected an unconscious reality about the whole group. Using the same format, we will create a Exquisite Corpse with media query in a html page.</p>
              <p>In the given html, there are 14 blank media queries. Each participant is responsible for writing the CSS for one media query in order below.</p>
              <ul class="mq">
                <li class="small">Narin: @media screen and (min-width: 640px) and (max-width: 710px) by 3pm 10/22/24</li>
                <li class="small">Jolin: @media screen and (min-width: 710px) and (max-width: 780px) by 4pm 10/22/24</li>
                <li class="small">Cindy: @media screen and (min-width: 780px) and (max-width: 850px) by 5pm 10/22/24</li>
                <li class="small">Claire: @media screen and (min-width: 850px) and (max-width: 920px) by 3pm 11/05/24</li>
                <li class="small">Radhika: @media screen and (min-width: 920px) and (max-width: 990px) by 4pm 11/05/24</li>
                <li class="small">Li June: @media screen and (min-width: 990px) and (max-width: 1060px) by 5pm 11/05/24</li>
                <li class="small">Brianna: @media screen and (min-width: 1060px) and (max-width: 1130px) by 6pm 11/05/24</li>
                <li class="small">Mike: @media screen and (min-width: 1130px) and (max-width: 1200px) by 3pm 11/12/24</li>
                <li class="small">Hyunmin: @media screen and (min-width: 1200px) and (max-width: 1270px) by 4pm 11/12/24</li>
                <li class="small">Janice: @media screen and (min-width: 1270px) and (max-width: 1340px) by 5pm 11/12/24</li>
                <li class="small">Cynthia: @media screen and (min-width: 1340px) and (max-width: 1410px) by 3pm 11/19/24</li>
                <li class="small">Sejal: @media screen and (min-width: 1410px) and (max-width: 1480px) by 4pm 11/19/24</li>
                <li class="small">Sophie: @media screen and (min-width: 1480px) and (max-width: 1550px) by 5pm 11/19/24</li>
                <li class="small">Lea: @media screen and (min-width: 1550px) by 5pm 11/21/24</li>
              </ul>
              <h5>Steps</h5>
              <ul>
                <li>Sync <a href="https://github.com/mkimk/gdfwf23" target="_blank" rel="noopener noreferrer">this repository</a> to your computer: Click <i>Code</i> button on the repository, with an option <i>Open with GitHub Desktop</i>. Then clone the repository in your local folder.</li>
                <li>Find the html page in the synced folder and open it in your text editor.</li>
                <li>In the HTML file, find the following code block; this is where you should insert your code:</li>
                <div class="code_block">
                  <span class="blue">@media</span> screen <span class="blue">and</span> <span class="yellow">(</span><span class="purple">min-width:</span> ###px<span class="yellow">)</span> <span class="blue">and</span> <span class="yellow">(</span><span class="purple">max-width:</span> ###px<span class="yellow">) &#123;</span><span class="green"> /*your name*/</span><br />
                  &#160;&#160; <span class="green"> // Your CSS code goes here </span><br />
                  <span class="yellow"> &#125;</span>
                </div>
                <li>Within the assigned time window, write CSS for your assigned media query. Considering the previous student’s media query styles and create a layout that works well at your aspect ratio. Make <i>at least 10 style changes</i> between yours and the previous query, and try to make smooth transitions between the changes. You are responsible only for the assigned media query, don’t manipulate other sections or HTML.</li>
                <li>Commit the file to GitHub, and verify that the changes are reflected on both the repository page (<a href="https://github.com/mkimk/wam1f24/" target="_blank">https://github.com/mkimk/wam1f24/</a>) and the live site (<a href="https://mkimk.github.io/wam1f24/" target="_blank">https://mkimk.github.io/wam1f24/</a>). After confirming the updates, send a Slack message to the student with the next task, informing them that you’ve completed your part. If there are any delays, be sure to communicate with the next person so everything stays on track!</li>
                <li>When we look at the final site, the page will animate between each student’s layout as the users resize the browser window.</li>
              </ul>
              <h5>References & Resources</h5>
              <ul>
                <li><a href="https://en.wikipedia.org/wiki/Exquisite_corpse" target="_blank" rel="noopener noreferrer">Exquisite Corpse</a></li>
                <li><a href="https://en.wikipedia.org/wiki/Round-robin_story" target="_blank" rel="noopener noreferrer">Round Robin Story</a></li>
                <li><a href="https://essenmitsosse.de/pixel/?showcase=true&slide=2" target="_blank" rel="noopener noreferrer">Marcus Blättermann, Responsive Pixel Art</a></li>
                <li><a href="https://www.dropbox.com/s/u8uvw3ojiivhlzz/Each_student_gets_one_media_query%20copy.html?dl=0" target="_blank" rel="noopener noreferrer">A HTML media query sample by Sophia</a></li>
                <li>Potential CSS properties</li>
                <ul>
                  <li class="small">Display: <span class="code">display</span>, <span class="code">z-index</span></li>
                  <li class="small">Position: <span class="code">top</span>, <span class="code">bottom</span>, <span class="code">left</span>, <span class="code">right</span></li>
                  <li class="small">Scale: <span class="code">width</span>, <span class="code">height</span>, <span class="code">max-width</span>, <span class="code">max-height</span></li>
                  <li class="small">Transform: <span class="code">transform</span>, <span class="code">transition</span></li>
                  <li class="small">Animation: <span class="code">@keyframes</span>, <span class="code">animation</span></li>
                  <li class="small">Style: <span class="code">background</span>, <span class="code">border</span>, <span class="code">box-shadow</span>, <span class="code">opacity</span>, <span class="code">filter</span></li>
                  <li class="small">Others: <span class="code">content</span>, <span class="code">mix-blend-mode</span></li>
                </ul>
              </ul>
              <span class="small">Initial assignment designed with <a href="https://sophiaspitulnik.com/index.html" target="_blank" rel="noopener noreferrer">Sophia Spitulnik</a> (RISD GD BFA 19)</span>
            </div>
          </List>
        </Collapse > 
        {/* <ListItem id='e8' className="accordion" button onClick={() => handleClick12("e8")}>
                <ListItemText primary='Exercise 7' className="accordion-heading  maxw-20" /> Sentence Generator
            </ListItem>
            <Collapse in={!e7} timeout="auto"  unmountOnExit>
              <List component="div" disablePadding>
              <div className="accordion-content">
                <h6 style={{ marginTop: `0rem`}}>Demo</h6>
                <h5>Step 1</h5>
                <ul>
                  <li>Store the following into variables: noun 1, noun 2, adjective 1.</li>
                  <li>Output your fortune to the screen like so: “X is (more) Y (er) than Z.”</li>
                  <li>Create 5 different versions of the sentence with different variables.</li>
                </ul>
                <h5>Step 2</h5>
                <ul>
                  <li>Make a list of words for each variable: noun 1, noun2, adjective 1.</li>
                  <li>Create a ranomly generated fortune by using the variable lists and output the fortune to the screen like so: “X is (more) Y (er) than Z.”</li>
                  <li>Style the html page.</li>
                  <li>Upload all your html files to your GitHub repository, and add links to the pages on the GitHub homepage. Post the links in Slack with the channel <span class="code">#(yourname)</span>.</li>
                </ul>
              </div>
              </List>
            </Collapse> */}
      </div >
    </Layout >
  )
}

export default IndexPage




export const query = graphql`
  query {
    allMarkdownRemark(
        sort: { fields: [frontmatter___date], order: ASC } 
        filter: {fileAbsolutePath: {regex: "/t3f19/_project/.*.md$/"}}
        ) {
      totalCount
      edges {
        node {
          html
          id
          frontmatter {
            title
            date
          }
          fields {
            slug
          }
        }
      }
    }
  }
`